import axios from 'axios';

const RESOURCE_NAME = '/startup/profile';

export default {

    getInfo() {
        return axios.get(`${RESOURCE_NAME}/get-info`)
    },

    saveInfo(data) {
        return axios.post(`${RESOURCE_NAME}/save-info`, data)
    },

    profileComplete() {
        return axios.get(`${RESOURCE_NAME}/profile-complete`)
    },
}